import React from "react";

const AlternateLink = ({ form, text, onClick, id }) => {
  function handleClick(event) {
    event.preventDefault();
    onClick(form)(event);
  }

  return (
    <div style={{ width: "100%" }}>
      <span className="flex justify-end" id={id}>
        <a
          className="block body-s mt2 mb5 text-black-tint-70 underline"
          onClick={handleClick}
          style={{ cursor: "pointer" }}
        >
          {text}
        </a>
      </span>
    </div>
  );
};

export { AlternateLink };
